import clsx from 'clsx';
import styles from './VehiclePlate.module.css';
import CarIcon from '../../assets/icons/car.svg?react';
import { LFC } from '../../types';

interface VehiclePlateProps {
  active?: boolean;
  className?: string;
}

export const VehiclePlate: LFC<VehiclePlateProps> = ({
  children,
  className,
  active,
  ...props
}) => (
  <div className={clsx(styles.vehicle, className)} {...props}>
    <CarIcon className={clsx(styles.icon, { [styles.active]: active })} />{' '}
    {children}
  </div>
);
